import { setupModal, setModalListeners, openModal } from "../utils/modal";
import { getPhoneMask } from "../utils/phone-mask";
import sendData from "./senddata";

const validateForm = () => {
  const form = document.querySelector("form");
  const address = form.getAttribute("action");
  const method = form.getAttribute("method");
  const noConnection = form.getAttribute("data-noConnect");
  const phoneInput = document.querySelector("#form-phone");
  const hotelsSelect = document.querySelector("#form-hotels");
  const emailInput = document.querySelector("#form-email");
  const formButton = document.querySelector(".form__button");
  const formDate1 = document.querySelector("#form-travel_date");
  const formDate2 = document.querySelector("#form-date_trip");
  const submitButton = document.querySelector("[type=submit]");
  let formData;
  let submitFlag = false;

  formDate1.setAttribute("autocomplete", "off");
  formDate2.setAttribute("autocomplete", "off");
  phoneInput.setAttribute("autocomplete", "off");

  if (phoneInput) {
    phoneInput.addEventListener("keydown", getPhoneMask);
  }


  const onError = (message) => {
    console.log(message);
    submitButton.disabled = true;
    submitButton.classList.add("form__button--disabled");
    throw new Error();
  };

  const onSuccess = (responseSuccess) => {
    submitButton.setAttribute("data-modal", "success");
    const modalSuccessBtns = document.querySelectorAll(
      '[data-modal="success"]'
    );
    const modalSuccess = document.querySelector(".modal--success");
    if (modalSuccess && modalSuccessBtns.length) {
      //setupModal(modalSuccess, false, modalSuccessBtns);
      setModalListeners(modalSuccess, false, false);
      openModal(modalSuccess);
    }
  };

  form.addEventListener("change", () => {
    formData = {
      company: document.querySelector("input[name=company]").value,
      manager: document.querySelector("input[name=manager]").value,
      email: document.querySelector("input[name=email]").value,
      phone: document.querySelector("input[name=phone]").value,
      hotel: hotelsSelect.options[hotelsSelect.selectedIndex].text,
      comment: document.querySelector("input[name=comment]").value,
      travel_date: document.querySelector("input[name=travel_date]").value,
      date: document.querySelector("input[name=date_trip]").value,
      name_tourist: [],
      surname_tourist: [],
    };

    if (formData) {
      let inputsName = document.querySelectorAll(".form__input--tourist-name");
      let inputsSurname = document.querySelectorAll(
        ".form__input--tourist-surname"
      );

      inputsName.forEach((name) => {
        if (name.value) {
          formData.name_tourist.push(name.value);
        }
      });

      inputsSurname.forEach((surname) => {
        if (surname.value) {
          formData.surname_tourist.push(surname.value);
        }
      });
    }
  });

  // Add the novalidate attribute when the JS loads
  var forms = document.querySelectorAll(".validate");

  for (var i = 0; i < forms.length; i++) {
    forms[i].setAttribute("novalidate", true);
  }

  // Validate the field
  var hasError = function (field) {
    // Don't validate submits, buttons, file and reset inputs, and disabled fields
    if (
      field.disabled ||
      field.type === "file" ||
      field.type === "reset" ||
      field.type === "submit" ||
      field.type === "button" ||
      field.type === "link" ||
      field.type === "overlay" ||
      field.attributes === undefined ||
      field === undefined
    )
      return;

    // Get validity

    var validity = field.validity;

    // If valid, return null
    if (validity === undefined) return;

    if (validity.valid) return;

    // If field is required and empty
    if (validity.valueMissing) return "Заполните это поле";

    // If not the right type
    if (validity.typeMismatch) {
      // Email
      if (field.type === "email") return "Введите корректный email адрес";

      // tel
      if (field.type === "tel") return "Введите корректный номер";
    }

    // If pattern doesn't match
    if (validity.patternMismatch) {
      // If pattern info is included, return custom error
      if (field.hasAttribute("title")) return field.getAttribute("title");
      if (field.type === "tel") return "Введите корректный номер";

      // Otherwise, generic error
      return "Введите корректное значение";
    }

    // If all else fails, return a generic catchall error
    return "Некорректное значение.";
  };

  // Show an error message
  var showError = function (field, error) {
    // Add error class to field
    field.classList.add("error");

    // Get field id or name
    var id = field.id || field.name;
    if (!id) return;

    // Check if error message field already exists
    // If not, create one
    var message = field.form.querySelector(".error-message#error-for-" + id);
    if (!message) {
      message = document.createElement("div");
      message.className = "error-message";
      message.id = "error-for-" + id;

      // If the field is a radio button or checkbox, insert error after the label
      var label;
      if (field.type === "radio" || field.type === "checkbox") {
        label =
          field.form.querySelector('label[for="' + id + '"]') ||
          field.parentNode;
        if (label) {
          label.parentNode.insertBefore(message, label.nextSibling);
        }
      }

      // Otherwise, insert it after the field
      if (!label) {
        field.parentNode.insertBefore(message, field.nextSibling);
      }
    }

    // Add ARIA role to the field
    // field.setAttribute("aria-describedby", "error-for-" + id);

    // Update error message
    message.innerHTML = error;

    // Show error message
    message.style.display = "none";
    message.style.visibility = "visible";
  };

  // Remove the error message
  var removeError = function (field) {
    // Remove error class to field
    field.classList.remove("error");

    // Remove ARIA role from the field
    field.removeAttribute("aria-describedby");

    // If the field is a radio button and part of a group, remove error from all and get the last item in the group
    if (field.type === "radio" && field.name) {
      var group = document.getElementsByName(field.name);
      if (group.length > 0) {
        for (var i = 0; i < group.length; i++) {
          // Only check fields in current form
          if (group[i].form !== field.form) continue;
          group[i].classList.remove("error");
        }
        field = group[group.length - 1];
      }
    }

    // Get field id or name
    var id = field.id || field.name;
    if (!id) return;
  };

  var deleteAllErrorMessage = function () {
    var allErrorMessages = document.querySelectorAll(".error");

    if (allErrorMessages) {
      allErrorMessages.forEach(function (element) {
        element.classList.remove("error");
      });
    }
  };

  // Listen to all blur events
  document.addEventListener(
    "blur",
    function (event) {
      if (event.target.body) {
        return;
      }

      // Only run if the field is in a form to be validated

      if (event.target.form) {
        if (!event.target.form.classList.contains("validate")) return;
      }

      // Validate the field
      var error = hasError(event.target);

      var deleteErrorMessage = function () {
        if (event.target) {
          event.target.classList.remove("error");
        }
      };

      // If there's an error, show it
      if (error) {
        showError(event.target, error);
        // window.setTimeout(deleteErrorMessage, 2000);
        return;
      }

      // Otherwise, remove any existing error message
      removeError(event.target);
    },
    true
  );

  // deleteAllErrorMessage();

  // Check all fields on submit

  var formsListener = function (event) {
    // Only run on forms flagged for validation
    if (!event.target.classList.contains("validate")) return;

    // Get all of the form elements
    var fields = event.target.elements;

    // Validate each field
    // Store the first field with an error to a variable so we can bring it into focus later
    var error, hasErrors;
    for (var i = 0; i < fields.length; i++) {
      error = hasError(fields[i]);
      if (error) {
        showError(fields[i], error);
        if (!hasErrors) {
          hasErrors = fields[i];
        }

        // window.setTimeout(deleteAllErrorMessage, 2000);
      }
    }

    // If there are errrors, don't submit form and focus on first element with error
    if (hasErrors) {
      event.preventDefault();
      hasErrors.focus();
      document.addEventListener("submit", formsListener, false);

      // console.log("ERROR");
    }

    if (!hasErrors) {
      event.preventDefault();
      // console.log("SUCCESS");

      submitButton.addEventListener("click", function (evt) {
        evt.preventDefault();
        //console.log(formData);
        let dataToSend = new FormData();
        for (var key in formData) {
  //        console.log('key', key, 'value', formData[key]);
          dataToSend.append(key, formData[key]);
        }
//        console.log(dataToSend);
        // for (var value of dataToSend.entries()) {
        //   console.log(value);
        // }
        sendData(address, method, onSuccess, onError, dataToSend);
      });

      
      submitButton.click();

      //submitButton.disabled = true;
      //submitButton.classList.add("form__button--disabled");

      // console.log(formData);

      form.reset();
    }
  };

  function validateForms() {
    forms = document.querySelectorAll(".validate");

    for (var i = 0; i < forms.length; i++) {
      forms[i].setAttribute("novalidate", true);
    }

    document.addEventListener("submit", formsListener, false);
  }

  function removeListeners() {
    document.removeEventListener("submit", formsListener, false);
  }

  validateForms();
};

export { validateForm };
